import Vue from 'vue'
import store from '../../store/store';
import Router from 'vue-router'
import setLoginParameters from '../Unit/set-login-and-logout-parameters'
import axios from "../plugins/axios";
import {mapMutations} from "vuex";

Vue.use(Router)
Vue.prototype.$session = null;

const routes = [
    {
      path: '/',
      name: 'index',
      meta:
        {
          page: 'index',
          public: true
        },
      component: resolve => require(['@/components/home/offline'], resolve)
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      meta:
        {
          page: 'withdraw',
          public: false
        },
      component: resolve => require(['@/components/home/withdraw'], resolve)
    },
     {
      path: '/withdrawal',
      name: 'withdrawal',
      meta:
        {
          page: 'withdraw',
          public: false
        },
      component: resolve => require(['@/components/home/withdraw'], resolve)
    },  
    {
      path: '/withdraw/:type',
      name: 'withdraw',
      meta:
        {
          page: 'withdraw_item',
          public: false
        },
      component: resolve => require(['@/components/home/methods'], resolve)
    },
    {
      path: '/deposit',
      name: 'deposit',
      meta:
        {
          page: 'deposit',
          public: false
        },
      component: resolve => require(['@/components/home/deposit'], resolve)
    },
    {
      path: '/deposit/:type',
      name: 'deposit',
      meta:
        {
          page: 'deposit_item',
          public: false
        },
      component: resolve => require(['@/components/home/methods'], resolve)
    },
    {
      path: '*',
      name: 'all',
      redirect: '/'
    }
];

// Dev-only: a route for manually entering a bearer token, bypassing the
// real mobile WebView. In production builds (NODE_ENV === 'production')
// this branch never runs, so the route is never registered and never
// ends up in the bundle.
if (process.env.NODE_ENV !== 'production') {
  routes.push({
    path: '/dev-login',
    name: 'dev-login',
    meta: {
      page: 'dev-login',
      public: true
    },
    component: resolve => require(['@/components/dev/DevLogin'], resolve)
  });
}

const router = new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: routes
});

// Dev-only: if config/dev.env.js sets a secret test bearer (DEV_AUTO_BEARER),
// try logging in with it automatically instead of landing on /dev-login.
// Only attempted once per page load, so it doesn't loop if the test bearer
// turns out to be invalid.
let devAutoBearerAttempted = false;

router.beforeResolve((to, from, next) => {
  if (to.query.bearer) {
    console.log('New Bearer', to.query.bearer );
    process.$session = null;

    validateToken(to, from, next, process);
  }else {
    if(process.$session){
      console.log('Used Existing Session ', process.$session );
      next();
    }else{
      if(to.name == 'index' && process.env.NODE_ENV !== 'production' && process.env.DEV_AUTO_BEARER && !devAutoBearerAttempted){
        devAutoBearerAttempted = true;
        router.push({ path: '/', query: { bearer: process.env.DEV_AUTO_BEARER } });
      }else if(to.meta.public){
        // public routes (index, and dev-only /dev-login) are allowed without a session
        next();
      }else{
        router.push('/');
      }

    }
  }
});

/**
 *
 * @param to
 * @param from
 * @param next
 * @returns {Promise<void>}
 */
async function  validateToken(to, from, next, oVue){
 
  await get_token(to.query.bearer)
    .then(response => {
      let token = response.data.token;
      setLoginParameters.setToken(token);

      let tempObj = {};
      tempObj.email = response.data.user_email;
      tempObj.id = response.data.user_id;
      tempObj.account = response.data.user_account;
      tempObj.allow_p2p = response.data.allow_p2p;
      tempObj.balance = response.data.balance;
      tempObj.token = response.data.token;
      let jsonStr = JSON.stringify(tempObj);
      if(localStorage.persistent !== undefined){
        if(JSON.parse(localStorage.persistent).id !== undefined 
            && JSON.parse(localStorage.persistent).id != response.data.user_id){
              localStorage.removeItem('trc20addr');
              localStorage.removeItem('trc20addrValid');
              localStorage.removeItem('erc20addr');
              localStorage.removeItem('erc20addrValid');
              localStorage.removeItem('trc20v2addr');
              localStorage.removeItem('trc20v2addrValid');
        }
      }
      localStorage.setItem('persistent', jsonStr);

       oVue.$session = tempObj;

       console.log('Created New Session ', oVue , process.$session);

       store.commit('changePreloaderVisible', false)

      if(to.query.route){
        router.push('/'+to.query.route)
      }else{
        router.push('/')
      }
      
    })
    .catch(error => {
      console.log(error)
    })
}


/**
 * @param token
 * @returns {*}
 */
function get_token(token) {
  return axios.post(`rlogin`, {bearer: token})
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js